export default "__VITE_ASSET__kZgIW$us__"